import { Carousels } from './Carousel'

export class CardCarousel extends Carousels.FlickityCarousel {
    constructor(container, options) {
        super(container, options)
        this.options = Object.assign({
            ...this.options,
        }, {
            lazyLoad: 4,
            bgLazyLoad: 4,
            contain: true,
            freeScroll: false,
            pageDots: false,
            cellAlign: 'left',
            ...options,
            ...this.$slider.dataset.carouselOptions && JSON.parse(this.$slider.dataset.carouselOptions)
        })
        this.carouselType = this.$slider.dataset.carouselType || ''
        this.init()
    }

    init() {
        this.customizeCarouselOptions()
        super.init()
    }

    customizeCarouselOptions() {
        switch(this.carouselType) {
            case 'variable-freescroll':
                this.updateOptions({
                    ...this.options,
                    ...{
                        prevNextButtons: false,
                        cellAlign: 'center',
                        freeScroll: true
                    }
                })
                break
            default: this.updateOptions({
                ...this.options
            })
        }
    }


    
}

export default CardCarousel